import { jsx } from "react/jsx-runtime";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { validateTidalLicense } from "../../base/index.js";
function CameraAlt(props) {
  return /* @__PURE__ */ jsx(
    CameraAltIcon,
    {
      "data-testid": "CameraAlt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CameraAlt",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
CameraAlt.tidalIconMeta = {
  categories: "devices,photos",
  name: "CameraAlt"
};
validateTidalLicense();
export {
  CameraAlt
};
//# sourceMappingURL=CameraAlt.js.map
